export default class Csv {
  constructor (separator = ';', encoding = 'UTF-8') {
    this.separator = separator
    this.encoding = encoding
    this.rows = []
  }

  addRow (row) {
    let escaped = row.map(col => {
      return col
        ? col.toString()
          .replace(/"/, '""')
          .replace(/\n/, '\\n')
        : ''
    })

    this.rows.push(escaped)
  }

  toString () {
    // @TODO: Convert to target encoding

    return '\ufeff' + this.rows
      .map(row => row.map(col => `"${col}"`).join(this.separator))
      .join('\r\n')
  }

  download (filename) {
    let a = document.createElement('a')
    a.style = 'display: none'
    document.body.appendChild(a)

    let data = this.toString()
    let blob = new Blob([data], { type: 'text/csv' })
    let url = window.URL.createObjectURL(blob)

    a.href = url
    a.download = filename
    a.click()
    window.URL.revokeObjectURL(url)

    a.remove()
  }
}



// WEBPACK FOOTER //
// ./src/utils/Csv.js